import axiosInstance from "./axios";

export const fetchZones = () => {
  return axiosInstance.get("/zones");
};

// Paginated + searchable zones, used by the async ZoneSelect dropdown.
export const searchZones = ({ page = 1, perPage = 50, search = "" } = {}) => {
  return axiosInstance.get("/zones", {
    params: { page, per_page: perPage, search: search || undefined },
  });
};

export const fetchZoneById = (id) => {
  return axiosInstance.get(`/zones/${id}`);
};

export const createZone = (zoneData) => {
  return axiosInstance.post("/zones", zoneData);
};

export const updateZone = (id, zoneData) => {
  return axiosInstance.put(`/zones/${id}`, zoneData);
};

export const deleteZone = (id) => {
  return axiosInstance.delete(`/zones/${id}`);
};
